import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { ContactAppManager } from 'apps/home/contact/app';
import { withNamespaces, Trans } from 'react-i18next';

import DocumentHead from 'legacyComponents/documentHead';
import { Wizard } from 'libs/wizards/index';

import { HeaderMarginTop as Main } from 'legacyComponents/styled/lib';

@withNamespaces()
@observer
export class Contact extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ContactAppManager(null, {});
  }

  render() {
    // add an og:image
    return (
      <Main>
        <DocumentHead
          title={<Trans>Contact</Trans>}
          description={
            <Trans>
              Contact Wikifactory - the social design and production platform
            </Trans>
          }
        />
        <Wizard wizard={this.appManager.contactApp.wizard} />
      </Main>
    );
  }
}

Contact.propTypes = {
  t: PropTypes.func,
};
